export enum TransitionStage {
  preInit = 'pre-init',
  /** a stage exist only during internal calculation */
  __internal__preInitDirectRemove = '__internal__pre-init-direct-remove',
  init = 'init',
  enter = 'enter',
  normal = 'normal',
  /** a stage exist only during internal calculation */
  preLeave = 'pre-leave',
  leave = 'leave',
}
